import axios from '../utils/axios';

export default function deactivateSeekerSubscriptions(adminId,data) {
    return (
        axios.post('/admin/' + adminId + '/manageSeekerSubscriptions/subscription/admin/deactivate-subscription?type=ea', data )
    )
}
